import { render, staticRenderFns } from "./AnonymizationModal.vue?vue&type=template&id=7c06faca&scoped=true&"
import script from "./AnonymizationModal.vue?vue&type=script&lang=js&"
export * from "./AnonymizationModal.vue?vue&type=script&lang=js&"
import style0 from "./AnonymizationModal.vue?vue&type=style&index=0&id=7c06faca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c06faca",
  null
  
)

export default component.exports